import { IQuoteSla } from 'types/quote.types';
import { calcBusinessTimeUTC, convertMsToTimeParts } from '../../utils/common';

interface IQuoteSlaTimerCell {
  sla: IQuoteSla;
}

export const QuoteSlaTimerCell = ({ sla }: IQuoteSlaTimerCell) => {
  const elapsedTime = sla?.startsAt ? calcBusinessTimeUTC(sla.startsAt, new Date().toISOString()) : null;
  const { text } = convertMsToTimeParts(elapsedTime ?? 0);

  return <>{text}</>;
};
